import React, {
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import {
  Textarea,
  CustomApplicationForm,
} from 'components';
import { ERRORS, URL } from 'appConstants';
import { toast } from 'react-toastify';
import { _t } from 'utils';
import { RequestStatus, State } from 'types';
import styles from './styles.module.scss';

type Values = {
  text: string,
};

const initialValues: Values = {
  text: '',
};

const validationSchema = object().shape({
  text: string().required(ERRORS.required),
});

const CustomData = new FormData();

const PersonalFaqRequest = () => {
  const [status, setStatus] = useState<'INIT' | 'SUCCESS'>('INIT');
  const token = useSelector(({ me }: State) => me.token);

  const {
    values,
    isValid,
    errors,
    touched,
    handleChange,
    handleSubmit,
    // setFieldValue,
    resetForm,
  } = useFormik<Values>({
    initialValues,
    validationSchema,
    validateOnMount: true,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    onSubmit: () => upload(),
  });

  const upload = () => {
    CustomData.append('text', values.text);

    fetch(URL.PERSONAL.FAQ.SEND, {
      method: 'POST',
      mode: 'cors',
      body: CustomData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return false;
      })
      .then(() => {
        toast.success(_t('Данные обновлены'));
        setStatus('SUCCESS');
        resetForm();
      })
      .catch((err) => toast.error(_t(err.response.data.detail || 'Ошибка загрузки, повторите позже')));
  };

  const addFile = (value: File) => CustomData.append('file', value);

  return (
    <CustomApplicationForm
      onSubmit={handleSubmit}
      openerName="Отправить заявку"
      titleName="Задайте свой вопрос и мы ответим на него в ближайшее время"
      disabledSubmit={isValid && !isValid}
      autoClose={status === RequestStatus.SUCCESS}
      attachFile
      attachOnChange={addFile}
    >
      <Textarea
        name="text"
        placeholder="Опишите вашу проблему"
        className={styles.textarea}
        error={errors.text && touched.text ? errors.text : ''}
        value={values.text}
        onChange={handleChange}
      />
    </CustomApplicationForm>
  );
};

export default PersonalFaqRequest;
